
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Voici les foyers de Covid en Suisse, commune par commune`}</h1>
    <h2>{`De nouvelles données de l'Office fédéral de la santé publique montrent quelles régions ont été particulièrement touchées, de la première à la troisième vague.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;